// NameSettings: editor for the display name.

import { useState } from "react";
import { generateName } from "../lib/displayName.js";

export interface NameSettingsProps {
  name: string;
  participants: { clientId: string; name: string }[];
  selfClientId: string;
  onSave: (name: string) => void;
}

export function NameSettings({ name, participants, selfClientId, onSave }: NameSettingsProps): JSX.Element {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(name);

  const startEdit = () => {
    setDraft(name);
    setEditing(true);
  };
  const save = () => {
    const t = draft.trim().slice(0, 32);
    if (t && t !== name) onSave(t);
    setEditing(false);
  };
  const cancel = () => setEditing(false);
  const regenerate = () => {
    const fresh = generateName();
    setDraft(fresh);
  };

  return (
    <section className="settings">
      <div className="row">
        {editing ? (
          <>
            <input
              type="text"
              maxLength={32}
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") save();
                if (e.key === "Escape") cancel();
              }}
              autoFocus
            />
            <button onClick={regenerate} title="Generate random name">⟳</button>
            <button onClick={save}>Save</button>
            <button onClick={cancel}>Cancel</button>
          </>
        ) : (
          <>
            <span className="name">{name}</span>
            <button onClick={startEdit}>Edit name</button>
          </>
        )}
      </div>
      <div className="participants">
        <span className="label">In room:</span>
        {participants.length === 0 ? (
          <span className="empty">just you</span>
        ) : (
          participants.map((p) => (
            <span key={p.clientId} className={`badge${p.clientId === selfClientId ? " self" : ""}`}>
              {p.name}
            </span>
          ))
        )}
      </div>
    </section>
  );
}